function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "color(display-p3 .922 1 .91)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29 16c0 7.18-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3s13 5.82 13 13zm-6.605-2.549a.6.6 0 10-.79-.902l-7.578 6.63-3.603-3.603a.6.6 0 00-.848.848l4 4a.6.6 0 00.82.027l8-7z",
  fill: "color(display-p3 .0902 .4353 .4118)"
});

function SvgTodoActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iMTYiIGZpbGw9IiNFQkZGRTgiIHN0eWxlPSJmaWxsOiNFQkZGRTg7ZmlsbDpjb2xvcihkaXNwbGF5LXAzIDAuOTIyMCAxLjAwMDAgMC45MTAwKTtmaWxsLW9wYWNpdHk6MTsiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOSAxNkMyOSAyMy4xNzk3IDIzLjE3OTcgMjkgMTYgMjlDOC44MjAzIDI5IDMgMjMuMTc5NyAzIDE2QzMgOC44MjAzIDguODIwMyAzIDE2IDNDMjMuMTc5NyAzIDI5IDguODIwMyAyOSAxNlpNMjIuMzk1MSAxMy40NTE1QzIyLjY0NDUgMTMuMjMzMyAyMi42Njk4IDEyLjg1NDMgMjIuNDUxNSAxMi42MDQ5QzIyLjIzMzMgMTIuMzU1NSAyMS44NTQzIDEyLjMzMDIgMjEuNjA0OSAxMi41NDg1TDE0LjAyNzMgMTkuMTc4OEwxMC40MjQzIDE1LjU3NTdDMTAuMTg5OSAxNS4zNDE0IDkuODEwMDUgMTUuMzQxNCA5LjU3NTc0IDE1LjU3NTdDOS4zNDE0MiAxNS44MTAxIDkuMzQxNDIgMTYuMTg5OSA5LjU3NTc0IDE2LjQyNDNMMTMuNTc1NyAyMC40MjQzQzEzLjc5OTEgMjAuNjQ3NiAxNC4xNTc0IDIwLjY1OTYgMTQuMzk1MSAyMC40NTE1TDIyLjM5NTEgMTMuNDUxNVoiIGZpbGw9IiMxNzZGNjkiIHN0eWxlPSJmaWxsOiMxNzZGNjk7ZmlsbDpjb2xvcihkaXNwbGF5LXAzIDAuMDkwMiAwLjQzNTMgMC40MTE4KTtmaWxsLW9wYWNpdHk6MTsiLz4KPC9zdmc+Cg==";
export { SvgTodoActive as ReactComponent };